/*
  COTANTIN — 「ご一緒に」（VID 適用 実装指示書 v1.16 §3.3.12）
  snippets/cotantin-pair.liquid が出す <cotantin-pair> を動かす。

  - A／B：初回に cookie「cotantin_pair」へ A か B を保存（30 日・ブラウザ単位）。
    その側のカード（登録が 1 点の商品は data-side="*" の 1 枚）を出す
  - 計測：カードが画面に入ったら pair_view、「追加する」で pair_add、「商品を見る」で pair_click（パラメータ variant＝A／B、product＝handle）。
    Shopify のカスタマーイベント（Shopify.analytics.publish）にだけ流し、GA4 へはカスタムピクセル「ご一緒に → GA4」が中継する
  - 「追加する」：カートに 1 点入れ、cart attribute の _pair_variant（A／B）と _pair_product（handle）を書く
    （注文に残るので、注文一覧だけで A／B の集計ができる）。
    カートでは再読み込み、商品ページではボタンを「追加しました」にしてカートの点数を更新する
*/
(function () {
  if (!window.customElements || customElements.get('cotantin-pair')) return;

  var COOKIE = 'cotantin_pair';

  function readSide() {
    var m = document.cookie.match(/(?:^|;\s*)cotantin_pair=(A|B)(?:;|$)/);
    if (m) return m[1];
    var side = Math.random() < 0.5 ? 'A' : 'B';
    document.cookie = COOKIE + '=' + side + '; max-age=' + 60 * 60 * 24 * 30 + '; path=/; SameSite=Lax';
    return side;
  }

  function track(name, params) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, params);
      }
    } catch (e) { /* 計測の失敗で操作を止めない */ }
    /* GA4 へはカスタムピクセル「ご一緒に → GA4」が中継する。ページの gtag を直接呼ぶと
       同じ表示が二重に数えられる（2026-09-27 に実測）ので、ここからは送らない */
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  class CotantinPair extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.side = readSide();
      this.card = this.querySelector('.ct-pair__card[data-side="' + this.side + '"]') ||
                  this.querySelector('.ct-pair__card[data-side="*"]');
      if (!this.card) return;

      // 登録が 1 点の商品は 1 点目＝A として数える
      this.reported = this.card.getAttribute('data-side') === '*' ? 'A' : this.side;
      this.product = this.card.getAttribute('data-product');
      this.card.hidden = false;
      this.hidden = false;

      var self = this;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.disconnect();
            track('pair_view', { variant: self.reported, product: self.product });
          });
        }, { threshold: 0.5 });
        io.observe(this.card);
      } else {
        track('pair_view', { variant: this.reported, product: this.product });
      }

      var button = this.card.querySelector('[data-pair-add]');
      if (button) button.addEventListener('click', this.add.bind(this, button));

      var link = this.card.querySelector('[data-pair-link]');
      if (link) link.addEventListener('click', function () {
        track('pair_click', { variant: self.reported, product: self.product });
      });
    }

    async add(button) {
      if (button.disabled) return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      track('pair_add', { variant: this.reported, product: this.product });

      try {
        var res = await fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(this.card.getAttribute('data-variant')), quantity: 1 }] })
        });
        if (!res.ok) throw new Error('add');

        await fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { _pair_variant: this.reported, _pair_product: this.product } })
        });

        if (this.getAttribute('data-context') === 'cart') {
          window.location.reload();
          return;
        }

        button.removeAttribute('aria-busy');
        button.textContent = this.getAttribute('data-added-label') || '追加しました';
        button.classList.add('is-added');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (e) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('cotantin-pair', CotantinPair);
})();
